<template>
    <nav>
        <div class="page-bar-wrapper">
            <div class="line">
                <!-- <div ref="progress" class="progress-bar"></div> -->
                <div class="progress-line line-1" ref="roundPageButton">
                    <p>Round</p>
                </div>
                <!-- <div class="progress-line line-2">
                    <p>E2</p>
                </div> -->
                <div class="progress-line line-3" ref="flatPageButton">
                    <p>Flat</p>
                </div>
                <!-- <div class="progress-line line-4">
                    <p>E4</p>
                </div> -->
                <div class="progress-line line-5" ref="hollowPageButton">
                    <p>Hollow</p>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
    export default {
        name: 'PageBar',
        methods: {
        round() {
            // console.log("Clicked!");
            // this.$emit('changeComponent', 'Simulation');
            this.$emit('changeComponent', 1);
            this.$refs.roundPageButton.style.backgroundColor = "#2D7BE5";
            this.$refs.flatPageButton.style.backgroundColor = "#212121";
            this.$refs.hollowPageButton.style.backgroundColor = "#212121";
        },
        flat(){
            this.$emit('changeComponent', 2);
            this.$refs.roundPageButton.style.backgroundColor = "#212121";
            this.$refs.flatPageButton.style.backgroundColor = "#459300";
            this.$refs.hollowPageButton.style.backgroundColor = "#212121";
        },
        hollow(){
            this.$emit('changeComponent', 3);
            this.$refs.roundPageButton.style.backgroundColor = "#212121";
            this.$refs.flatPageButton.style.backgroundColor = "#212121";
            this.$refs.hollowPageButton.style.backgroundColor = "#D2841A";
        },
        roundColor() {
            this.$refs.roundPageButton.style.backgroundColor = "#2D7BE5";
            this.$refs.flatPageButton.style.backgroundColor = "#212121";
            this.$refs.hollowPageButton.style.backgroundColor = "#212121";
        },
        flatColor() {
            this.$refs.roundPageButton.style.backgroundColor = "#212121";
            this.$refs.flatPageButton.style.backgroundColor = "#459300";
            this.$refs.hollowPageButton.style.backgroundColor = "#212121";
        },
        hollowColor() {
            this.$refs.roundPageButton.style.backgroundColor = "#212121";
            this.$refs.flatPageButton.style.backgroundColor = "#212121";
            this.$refs.hollowPageButton.style.backgroundColor = "#D2841A";
        }
    },
    created() {
    },
    mounted() {
        // window.scrollTo(0, 0);
        this.$refs.roundPageButton.addEventListener("click", this.round);
        this.$refs.flatPageButton.addEventListener("click", this.flat);
        this.$refs.hollowPageButton.addEventListener("click", this.hollow);
    }
    }
</script>

<style scoped>

    nav {
        min-height: 20px;
        height: 100px;
        /* height: 10vh; */
        /* width: calc(100% - 539px - 12vw - 100px); */
        /* width: calc(100% - 240px); */
        /* width: 100%; */
        /* width: calc(100% - 180px); */
        position: fixed;
        /* display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        justify-items: center; */
        /* background-color: purple; */
        /* opacity: .25; */
        /* top: 0; */
        /* left: 340px; */
        /* left: 120px; */
        /* left: 90px; */
        /* transform: translateX(-50%); */
        z-index: 99;

        /* height: 60.5vh; */
        width: 100px;
        /* background-color: red; */
        position: fixed;
        /* top: calc(20vh - 20px); */
        top: calc(20vh - 90px);
        /* transform: translateY(-50%); */
        left: 169px;
        z-index: 99;
    }

    .page-bar-wrapper {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: space-between;
        /* background-color: purple; */
    }

    .line {
        width: 100%;
        height: 2px;
        /* background-color: #212121; */
        /* background-color: red; */
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        /* bottom: 0; */
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        /* top: 50%;
        transform: translateY(-50%); */
        /* left: 50%; */
        /* transform: translateX(-50%); */
        transition: height .3s ease-in-out;
        box-sizing: border-box;
    }

    .progress-line {
        height: 100%;
        /* width: calc((100% / 5) - 20px); */
        /* max-width: calc(20% - 12vw); */
        /* max-width: 12vw; */
        /* width: calc( 20% - 1px); */
        /* width: calc(12vw + 18px); */
        width: calc(25%);
        /* padding: 5px 5px; */
        background-color: #212121;
        /* border-top: 0px solid #212121;
        border-left: 2px solid #212121;
        border-right: 2px solid #212121; */
        box-sizing: border-box;
        /* border-bottom: 2px solid #212121; */
        transition: height .3s ease-in-out, border .3s ease-in-out, background-color .3s ease-in-out;
        position: relative;
        /* box-shadow: inset 0px 0px 0px 10px red; */
    }

    .progress-line:hover {
        cursor: pointer;
        /* background-color: #2D7BE5; */
    }

    .progress-line:hover p {
        color: #2D7BE5;
    }

    .progress-line p {
        text-transform: uppercase;
        font-family: odisseia, sans-serif;
        font-weight: 600;
        position: absolute;
        top: calc(-100% - 2px);
        left: 50%;
        /* transform: translateX(-100%) translateY(-50%); */
        transform: rotate(-90deg) translateY(-50%);
        transform-origin: top left;
        /* transform-origin: middle; */
        /* transform-origin: left; */
        margin: 0;
        line-height: 16px;
        font-size: 16px;
        opacity: .20;
        transition: opacity .3s ease-in-out, bottom .3s ease-in-out, top .3s ease-in-out, color .3s ease-in-out;
    }

    .line-1 {
        /* border-color: #E5A52D; */
        /* background-color: #2D7BE5; */
    }

    .progress-bar {
        width: 20%;
        height: 100%;
        /* height: 33%; */
        background-color: #2D7BE5;
        transition: height .2s ease;
    }

    .page-bar-wrapper:hover .line {
        height: 10px;
        /* border-top: 10px solid; */
        /* border-bottom: 10px solid; */
    }

    .page-bar-wrapper:hover p {
        opacity: 1;
        /* top: calc(-100% - 1px); */
        /* bottom: -30px; */
    }

    .page-bar-wrapper:hover .line-1 {
        /* border-bottom: 10px solid #E5A52D; */
    }

    .progress-line:hover.line-3 {
        background-color: #459300;
    }

    .progress-line:hover.line-3 p {
        color: #459300;
    }

    .progress-line:hover.line-5 {
        background-color: #D2841A;
    }

    .progress-line:hover.line-5 p {
        color: #D2841A;
    }

</style>